export const STATUS_TYPES = {
  'SUCCESS': 'bg-active text-active',
  'ERROR': 'bg-error-light text-error',
  'WARNING': 'bg-[#FFF3D6] text-pending',
  'INFO': 'bg-[#EBF3FF] text-style',
  'NEUTRAL': 'text-[#939393] bg-[#ECECEC]',
  'DISABLED': 'bg-active text-active',
  'REJECTED': 'bg-[#FFF0E5] text-rejected',
} as const;

export type StatusType = keyof typeof STATUS_TYPES;